/**
 * Headers for every request to the agent server: the signed-in user's
 * access token for the workspace API (`<clientId>/.default`, the token the
 * backend accepts) and, in test-file mode, the test user. Returns a stable
 * async function, so a request object built once still sends a fresh token
 * on every call.
 */
import { useCallback } from 'react';
import { useMsalTokenProvider } from '~/hooks/auth/useMsalTokenProvider';
import AppConfig from '~/utils/appconfig';
import { agentRequestHeaders } from './agentRequest';

export function useAgentRequestHeaders(): () => Promise<
    Record<string, string>
> {
    const { tokenProvider } = useMsalTokenProvider({
        scopes: [`${AppConfig.clientId}/.default`],
    });
    return useCallback(async () => {
        const accessToken = await tokenProvider.getToken();
        return agentRequestHeaders(
            AppConfig.get('agentTestUser', ''),
            accessToken?.token ?? ''
        );
    }, [tokenProvider]);
}
